import { createFileRoute } from "@tanstack/react-router";
import SpravatoGriefDepression from "@/pages/SpravatoGriefDepression";
export const Route = createFileRoute("/spravato-for-grief-and-depression")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SPRAVATO® for Grief & Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "SPRAVATO® for grief-related depression at Neuro Wellness in Coral Springs, FL. FDA-cleared esketamine for grief that becomes treatment-resistant depression.",
        },
        {
          property: "og:title",
          content: "SPRAVATO® for Grief & Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "SPRAVATO® for grief-related depression at Neuro Wellness in Coral Springs, FL. FDA-cleared esketamine for grief that becomes treatment-resistant depression.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/spravato-for-grief-and-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/spravato-for-grief-and-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SpravatoGriefDepression />;
}
